var _path, _path2, _rect, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFitHeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4659 2.56509C12.5538 2.4783 12.6962 2.4783 12.7841 2.56509L13.6841 3.45398C13.772 3.54076 13.772 3.68146 13.6841 3.76825C13.5962 3.85503 13.4538 3.85503 13.3659 3.76825L12.85 3.25871L12.85 5.27778C12.85 5.40051 12.7493 5.5 12.625 5.5C12.5007 5.5 12.4 5.40051 12.4 5.27778L12.4 3.25871L11.8841 3.76825C11.7962 3.85503 11.6538 3.85503 11.5659 3.76825C11.478 3.68146 11.478 3.54076 11.5659 3.45398L12.4659 2.56509Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 5.5L14.5 5.5",
    stroke: "#28303F",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7.5,
    width: 11,
    height: 10,
    rx: 2,
    stroke: "#28303F",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5341 22.4349C12.4462 22.5217 12.3038 22.5217 12.2159 22.4349L11.3159 21.546C11.228 21.4592 11.228 21.3185 11.3159 21.2318C11.4038 21.145 11.5462 21.145 11.6341 21.2318L12.15 21.7413L12.15 19.7222C12.15 19.5995 12.2507 19.5 12.375 19.5C12.4993 19.5 12.6 19.5995 12.6 19.7222L12.6 21.7413L13.1159 21.2318C13.2038 21.145 13.3462 21.145 13.4341 21.2318C13.522 21.3185 13.522 21.4592 13.4341 21.546L12.5341 22.4349Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 19.5L10.5 19.5",
    stroke: "#28303F",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitHeight);
export default __webpack_public_path__ + "static/media/fitHeight.95ed6b04b099c4a12429c64145b9bacd.svg";
export { ForwardRef as ReactComponent };